import { CmsPublicationDetail } from '../../../../components/Cms';

export function CmsPublicationDetails() {
  return <CmsPublicationDetail />;
}
